var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.newVersion)?_c('StartYourJourneyForFreeV2',{attrs:{"stats":_vm.stats,"page":_vm.page}}):_c('StartYourJourneyForFree',{attrs:{"instructors":_vm.instructors,"stats":_vm.stats,"page":_vm.page}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }